// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

/* eslint-disable */

/**
 * This is a automatically generated component, do not edit it.
 * If you need to edit this component, move it to some other folder.
 */

import React from 'react';
function DrugIcon3(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <g
        fill="currentColor"
        clipPath="url(#a)"
      >
        <path d="M30.404 29.934a.333.333 0 0 0-.47.47c.386.39.456.506.643.506a.333.333 0 0 0 .237-.576l-.41-.4ZM31.644 27.377h-.576a.333.333 0 1 0 0 .667h.576a.333.333 0 1 0 0-.667ZM30.607 25.166a.333.333 0 0 0-.235-.566.333.333 0 0 0-.235.096l-.41.407a.333.333 0 0 0 .236.563c.177 0 .217-.073.644-.5ZM19.193 25.793h-3.527a.907.907 0 0 0-.906.907v1.11a.906.906 0 0 0 .906.906h3.527a.906.906 0 0 0 .907-.906V26.7a.907.907 0 0 0-.907-.907Zm.24 2.017a.24.24 0 0 1-.24.24h-3.527a.24.24 0 0 1-.24-.24V26.7a.24.24 0 0 1 .24-.24h3.527a.24.24 0 0 1 .24.24v1.11Z" />
        <path d="M26.847 24.85h-.413a1.844 1.844 0 0 0-1.717-2.516h-3.54a2.573 2.573 0 0 1-2.363-1.543c-8.2-18.67-7.613-17.41-7.813-17.607-.2-.19-.467-.294-.744-.29a1.52 1.52 0 0 0-.666.204L8.83 1.38A1.077 1.077 0 0 0 7.41.828L.667 3.794a1.08 1.08 0 0 0-.566 1.42l.753 1.717-.257.113a1.053 1.053 0 0 0-.543 1.39l8.723 19.87a4.853 4.853 0 0 0 4.44 2.9h8.59a3.453 3.453 0 0 0 1.86-.536h3.097a.894.894 0 0 0 .903-.9v-4.1a.81.81 0 0 0-.82-.817Zm-11.37-4.06-3.363-7.666a1.17 1.17 0 0 1 .093-1.123 1.194 1.194 0 0 1 2.09.173c4.144 9.427 3.904 8.85 3.904 8.884.226.498.57.935 1 1.273h-1.357a2.586 2.586 0 0 1-2.367-1.54ZM.741 8.335a.573.573 0 0 1 .296-.76l5.287-2.333c0 .283.03.26.803 2.017l-5.746 2.54-.64-1.464Zm6.48-3.47c2.96-1.3 2.79-1.243 2.946-1.243a.58.58 0 0 1 .53.333l.637 1.47-3.597 1.577-.716-1.633a.387.387 0 0 1 .2-.504Zm-6.3-.46 6.746-2.966a.413.413 0 0 1 .554.23l.753 1.713-7.51 3.287-.753-1.72a.417.417 0 0 1 .21-.544Zm12.296 26.134a4.184 4.184 0 0 1-3.826-2.504L1.647 10.408l9.96-4.374 2.12 4.83a1.86 1.86 0 0 0-2.223 2.534l3.363 7.666c.22.503.565.94 1 1.274h-2.42a.333.333 0 1 0 0 .666h11.27a1.179 1.179 0 0 1 1.117 1.557l-1.39 4.083a2.784 2.784 0 0 1-2.637 1.894h-8.59Zm13.784-.77a.224.224 0 0 1-.227.223h-2.333c.284-.334.503-.718.643-1.133l1.133-3.334h.637a.14.14 0 0 1 .147.144v4.1Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path
            fill="#fff"
            d="M0 0h32v32H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default DrugIcon3;
